export enum SELECTED_PERIOD {
  yearly = "cb8f84a0-4465-4ca9-8e4e-0c6841b1e28c",
  monthly = "7cc59b06-1cc9-475c-a9f5-72033463f785",
  daily = "5f252085-99a5-455c-a5f1-8c1d527f1b0e",
  hourly = "467e7e1f-b2fd-400b-9be7-7d5941e839fb",
}

export const EMPLOYEE_COST_SECTION_TYPES = {
  Price_to_the_client: {
    id: "735fb2bc-d173-4c16-9c97-af15378b3e84",
    name: "Price to the client",
  },
  Employee_net_salary: {
    id: "14ec0e16-4e72-42fa-89c1-661b585a22f3",
    name: "Employee net salary",
  },
  Gross_salary: {
    id: "374d996a-51d2-4272-8d15-0136ba69fc67",
    name: "Gross salary",
  },
};

export enum SELECTED_PERIOD_DIVIDER {
  monthly = 12,
  daily = 260,
  hourly = 2000,
}
